import PropTypes from "prop-types";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../state/modules/layout/constants";

export default {
  children: PropTypes.node.isRequired,
  viewportCategory: PropTypes.oneOf([
    SMALL_VIEWPORT,
    MEDIUM_VIEWPORT,
    LARGE_VIEWPORT
  ]).isRequired
};
